import { render, staticRenderFns } from "./newStorageCard.vue?vue&type=template&id=f2438a60&scoped=true&"
import script from "./newStorageCard.vue?vue&type=script&lang=js&"
export * from "./newStorageCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2438a60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/admin_admin-web_uLO7/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2438a60')) {
      api.createRecord('f2438a60', component.options)
    } else {
      api.reload('f2438a60', component.options)
    }
    module.hot.accept("./newStorageCard.vue?vue&type=template&id=f2438a60&scoped=true&", function () {
      api.rerender('f2438a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/dataManage/newStorageCard/newStorageCard.vue"
export default component.exports